import KaraokeOrderForm from './components/order/KaraokeOrderForm';
import KaraokeUploadForm from './components/upload/KaraokeUploadForm';
import CopyrightTransferForm from './components/copyright/CopyrightTransferForm';
import AuthorCopyrightTransferForm from './components/copyright/AuthorCopyrightTransferForm';
import RecipientCopyrightTransferForm from './components/copyright/RecipientCopyrightTransferForm';
import RecipientCopyrightTransferAmendmentForm from './components/copyright/RecipientCopyrightTransferAmendmentForm';
import KaraokeModificationForm from './components/modification/KaraokeModificationForm';
import KaraokeDistrubutionCancelForm from './components/modification/KaraokeDistrubutionCancelForm';
import KaraokeListView from './components/modification/KaraokeListView';
import KaraokeDetailsForm from './components/modification/KaraokeDetailsForm';
import KaraokeRegistrationStartForm from './components/modification/KaraokeRegistrationStartForm';
import KaraokeRegistrationCancelForm from './components/modification/KaraokeRegistrationCancelForm';
import { defaultKaraokeOrderClient, KaraokeOrderClientContext } from './context/KaraokeOrderClientContext';
import { defaultKaraokeUploadClient, KaraokeUploadClientContext } from './context/KaraokeUploadClientContext';
import { defaultNextoneOrderClient, NextoneOrderClientContext } from './context/NextoneOrderClientContext';
import { defaultKaraokeModificationClient, KaraokeModificationClientContext } from './context/KaraokeModificationClientContext';

const components = {
  KaraokeOrderForm: (props: {
    initialIsArtistLoggingIn: boolean,
    artistName: string,
    defaultCouponCode: string,
    balance: number,
    completedCount: number,
    musicId: number|null,
    defaultTitle: string|null,
    defaultTitleKana: string|null,
    defaultArtistName: string|null,
    defaultArtistNameKana: string|null,
    defaultComposerName: string|null,
    defaultLyricWriterName: string|null,
    basicAmount: number,
    royaltyOptionAmount: number,
    onvocalOptionAmount: number,
    duetOptionAmount: number,
    physicalOptionAmount: number,
    introClickOptionAmount: number,
  }) => (
    <KaraokeOrderClientContext.Provider value={defaultKaraokeOrderClient}>
      <KaraokeOrderForm {...props} />
    </KaraokeOrderClientContext.Provider>
  ),
  KaraokeUploadForm: (props: {
    uploadHash: string,
    modificationFeeAmount: number,
    remakeFeeAmount: number,
  }) => (
    <KaraokeUploadClientContext.Provider value={defaultKaraokeUploadClient}>
      <KaraokeUploadForm {...props} />
    </KaraokeUploadClientContext.Provider>
  ),
  CopyrightTransferForm: (props: {
    formHash: string,
    copyrightCollectDocument: string,
    independentCopyrightTransferDocument: string,
    karaokeOrder: {
      title: string,
      lyric_writer_name: string,
      composer_name: string,
      lyric_writer_name_kana: string,
      composer_name_kana: string,
      applicant_name: string,
    },
  }) => (
    <NextoneOrderClientContext.Provider value={defaultNextoneOrderClient}>
      <CopyrightTransferForm {...props} />
    </NextoneOrderClientContext.Provider>
  ),
  AuthorCopyrightTransferForm: (props: {
    document: string,
    formHash: string,
    karaokeAuthor: {
      pseudonym: string,
    },
    karaokeOrder: {
      applicant_name: string,
      applicant_address: string,
    },
  }) => (
    <NextoneOrderClientContext.Provider value={defaultNextoneOrderClient}>
      <AuthorCopyrightTransferForm {...props} />
    </NextoneOrderClientContext.Provider>
  ),
  RecipientCopyrightTransferForm: (props: {
    document: string,
    formHash: string,
    karaokeOrder: {
      applicant_name: string,
      applicant_address: string,
    },
  }) => (
    <NextoneOrderClientContext.Provider value={defaultNextoneOrderClient}>
      <RecipientCopyrightTransferForm {...props} />
    </NextoneOrderClientContext.Provider>
  ),
  RecipientCopyrightTransferAmendmentForm: (props: {
    document: string,
    formHash: string,
    karaokeOrder: {
      title: string,
      applicant_name: string,
    }
  }) => (
    <NextoneOrderClientContext.Provider value={defaultNextoneOrderClient}>
      <RecipientCopyrightTransferAmendmentForm {...props} />
    </NextoneOrderClientContext.Provider>
  ),
  KaraokeListView: (props: {
    karaokeOrders: {
      id: number,
      delivery_status: number,
      title: string,
      delivery_completed_date: string,
    }[],
  }) => (
    <KaraokeModificationClientContext.Provider value={defaultKaraokeModificationClient}>
      <KaraokeListView {...props} />
    </KaraokeModificationClientContext.Provider>
  ),
  KaraokeDetailsForm: (props: {
    karaokeOrder: {
      id: number,
      title: string,
      title_kana: string,
      artist_name: string,
      artist_name_kana: string,
      lyric_writer_name: string,
      composer_name: string,
      applicant_name: string,
      royalty_order: string,
      delivery_status: number,
      delivery_status_text: string,
      upload_hash: string,
      physical: number,
      already_entrusted: number,
      onvocal: number,
      duet: number,
    },
    isWaitingForPayment: boolean,
    isWaitingForUpload: boolean,
    isPaymentCompleted: boolean,
    isRoyaltyOptionSelected: boolean,
    isDeliveryCompleted: boolean,
    isRegistrationInProgress: boolean,
    shouldModifyWithFee: boolean,
    modificationFeeAmount: number,
  }) => (
    <KaraokeModificationClientContext.Provider value={defaultKaraokeModificationClient}>
      <KaraokeDetailsForm {...props} />
    </KaraokeModificationClientContext.Provider>
  ),
  KaraokeModificationForm: (props: {
    karaokeOrderId: number,
    isDeliveredInJoysound: boolean,
    shouldRemakeForModification: boolean,
    shouldModifyWithFee: boolean,
    remakeFeeAmount: number,
    modificationFeeAmount: number,
  }) => (
    <KaraokeModificationClientContext.Provider value={defaultKaraokeModificationClient}>
      <KaraokeModificationForm {...props} />
    </KaraokeModificationClientContext.Provider>
  ),
  KaraokeDistrubutionCancelForm: (props: {
    karaokeOrderId: number,
    isBeforePayment: boolean,
    shouldRefundOnCancellation: boolean,
    isDeliveredInJoysound: boolean,
  }) => (
    <KaraokeModificationClientContext.Provider value={defaultKaraokeModificationClient}>
      <KaraokeDistrubutionCancelForm {...props} />
    </KaraokeModificationClientContext.Provider>
  ),
  KaraokeRegistrationStartForm: (props: {
    karaokeOrderId: number,
    isBeforePayment: boolean,
    paymentAmount: number,
  }) => (
    <KaraokeModificationClientContext.Provider value={defaultKaraokeModificationClient}>
      <KaraokeRegistrationStartForm {...props} />
    </KaraokeModificationClientContext.Provider>
  ),
  KaraokeRegistrationCancelForm: (props: {
    karaokeOrderId: number,
    isBeforePayment: boolean,
    paymentAmount: number,
    shouldRefundOnCancellation: boolean,
    isAvailableOnNextone: boolean,
  }) => (
    <KaraokeModificationClientContext.Provider value={defaultKaraokeModificationClient}>
      <KaraokeRegistrationCancelForm {...props} />
    </KaraokeModificationClientContext.Provider>
  ),
};

if (!window.AppComponents) window.AppComponents = {};
(Object.keys(components) as (keyof typeof components)[]).forEach((name) => {
  window.AppComponents[name] = components[name];
});
